export enum Flows {
  Junior = 'junior',
  Adult = 'adult',
  Online = 'online',
  Aya = 'aya',
}

export type Flow = Flows.Junior | Flows.Adult | Flows.Online | Flows.Aya;

export const KAPLAN_FLOWS: Flow[] = [Flows.Junior, Flows.Adult, Flows.Online, Flows.Aya];
export const ALPADIA_FLOWS: Flow[] = [Flows.Junior, Flows.Adult, Flows.Aya];
